import { useEffect, useState } from 'react'

/**
 * «Сейчас» с точностью до минуты — общий тик сетки: линия текущего времени и
 * приглушение прошедшего обязаны двигаться одновременно.
 */
export function useNowMinute(): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(id)
  }, [])
  return now
}
